export default __webpack_public_path__ + "static/media/my_menu.ab723d5f.png";